export default function Location() {
  return (
    <section id="location" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">ロケーション & アクセス</h2>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <div className="rounded-3xl overflow-hidden shadow-lg h-96">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3238.6023835231936!2d139.88066107575065!3d35.735996172569656!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60228532a51fc64b%3A0xf45fb394a0b296e0!2z5bCP5bKpIOOCt-ODvOOCt-ODoyBTaGlzaGEgQmFyIFNwcmluZyBTdW4!5e0!3m2!1sja!2sjp!4v1773665284317!5m2!1sja!2sjp"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Spring Sun の地図"
            ></iframe>
          </div>
          
          <div className="flex flex-col justify-center">
            <div className="space-y-6">
              <div className="flex items-start space-x-4">
                <div className="w-14 h-14 bg-amber-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-map-pin-line text-2xl text-amber-600"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">住所</h3>
                  <p className="text-gray-600 text-lg">
                    〒133-0057<br />
                    東京都江戸川区西小岩５−１−１７ S&amp;Y 201号<br />
                    Shisha Cafe &amp; Bar Spring Sun
                  </p>
                </div>
              </div>
              
              <div className="flex items-start space-x-4">
                <div className="w-14 h-14 bg-amber-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-train-line text-2xl text-amber-600"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">アクセス</h3>
                  <p className="text-gray-600 text-lg">
                    JR総武線「小岩駅」より徒歩約5分<br />
                    京成線「京成小岩駅」より徒歩約10分
                  </p>
                </div>
              </div>
              
              <div className="flex items-start space-x-4">
                <div className="w-14 h-14 bg-amber-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-time-line text-2xl text-amber-600"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">営業時間</h3>
                  <p className="text-gray-600 text-lg">
                    月・火・木　18:00 - 24:00<br />
                    水・金　19:00 - 24:00<br />
                    定休日：土・日
                  </p>
                </div>
              </div>
              
              <div className="flex items-start space-x-4">
                <div className="w-14 h-14 bg-amber-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-line text-2xl text-amber-600"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">お電話</h3>
                  <p className="text-gray-600 text-lg">080-3554-7296</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
